import { CommonComponentProvider, useCommonComponentContext } from "./src/providers/CommonComponentProvider";

import ProfileContainer from "./src/containers/profile";

import ModuleCodename from "./src/containers/codename";
import CodenameEditContainer from "./src/containers/codename/edit";
import ModalCreateEditCodename from "./src/containers/codename/modalCreateEdit";
import CodenameContainer, { getAllDataCodename } from "./src/containers/codename/list";

import ModuleRole from "./src/containers/role";
import RoleContainer from "./src/containers/role/list";
import RoleEditContainer from "./src/containers/role/edit";

import ModuleResource from "./src/containers/resource";
import ResourceContainer from "./src/containers/resource/list";
import ResourceEditContainer from "./src/containers/resource/edit";

import ModuleOrganization from "./src/containers/organization";
import OrganizationListContainer from "./src/containers/organization/list";
import OrganizationEditContainer from "./src/containers/organization/edit";
import OrganizationGroupComponent from "./src/components/Organization/stepGroup";
import OrganizationStaffComponent from "./src/components/Organization/stepStaff";
import OrganizationBasicInfoComponent from "./src/components/Organization/stepBasicInfo";

import ModuleGroup from "./src/containers/group";
import GroupListContainer from "./src/containers/group/list";
import GroupEditContainer from "./src/containers/group/edit";

import ModuleStaff from "./src/containers/staff";
import StaffListContainer from "./src/containers/staff/list";
import StaffEditContainer from "./src/containers/staff/edit";
import ModalInvitationMember from "./src/components/Staff/modalInvitationMember";
import ModalCreateUpdateStaff from "./src/components/Staff/modalCreateUpdateMember";

import PDFViewerContainer from "./src/components/PDFViewer";
import WorkerNodeContainer from "./src/containers/workerNode";

import { MyInvitationContainer, ManageInvitationContainer as InvitationListContainer } from "./src/containers/invitation";

// Common Component
import Box from "./src/components/Box";
import Chip from "./src/components/Chip";
import Tabs from "./src/components/Tabs";
import Radio from "./src/components/Radio";
import Modal from "./src/components/Modal";
import Avatar from "./src/components/Avatar";
import Button from "./src/components/Button";
import Switch from "./src/components/Switch";
import Stepper from "./src/components/Stepper";
import Loading from "./src/components/Loading";
import CheckBox from "./src/components/CheckBox";
import SelectBox from "./src/components/SelectBox";
import FormField from "./src/components/FormField";
import TextField from "./src/components/TextField";
import EmailInput from "./src/components/EmailInput";
import DatePicker from "./src/components/DatePicker";
import TitleValue from "./src/components/TitleValue";
import Typography from "./src/components/Typography";
import TimePicker from "./src/components/TimePicker";
import RadioGroup from "./src/components/RadioGroup";
import CustomIcon from "./src/components/CustomIcon";
import Breadcrumbs from "./src/components/Breadcrumbs";
import VideoPlayer from "./src/components/VideoPlayer";
import Autocomplete from "./src/components/Autocomplete";
import AvatarPicker from "./src/components/AvatarPicker";
import FileUploader from "./src/components/FileUploader";
import ImageUploader from "./src/components/ImageUploader";
import VideoUploader from "./src/components/VideoUploader";
import DateTimePicker from "./src/components/DateTimePicker";
import CustomSnackbar from "./src/components/CustomSnackbar";
import InputListEmail from "./src/components/InputListEmail";
import SearchInputAPI from "./src/components/SearchInputAPI";
import InputHtmlEditor from "./src/components/InputHtmlEditor";
import QuillHtmlEditor from "./src/components/QuillHtmlEditor";
import InputHtmlUploadEditor from "./src/components/InputHtmlUploadEditor";
import CustomPopupMenu from "./src/components/CustomPopupMenu";
import PhoneNumberInput from "./src/components/PhoneNumberInput";
import CustomPagination from "./src/components/CustomPagination";
import ControlLabelCheckBox from "./src/components/ControlLabelCheckBox";
import SnackbarAlert from "./src/components/CustomSnackbar/SnackbarAlert";
import MultipleImageUploader from "./src/components/MultipleImageUploader";
import SnackbarMessage from "./src/components/CustomSnackbar/SnackbarMessage";
import TabMultiLanguage from "./src/components/MultiLanguage/tabMultiLanguage";
import ModalManageOrganization from "./src/components/ModalManageOrganization";
import SelectMultiLanguage from "./src/components/MultiLanguage/selectMultiLanguage";
import CircularProgress from "./src/components/CircularProgress";
import ColorPicker from "./src/components/ColorPicker";
import SingleImageUploader from "./src/components/SingleImageUploader";
import ImageLibrary from "./src/components/ImageLibrary";
import ModalCreateUpdateGroup, { CardCreateUpdateGroup } from "./src/components/Group/modalCreateUpdateGroup";

//
import Faq from "./src/components/Faq";
import DataTable from "./src/components/DataTable";
import DataTableFilter from "./src/components/DataTable/Filter";
import CustomMenuItem from "./src/components/DataTable/CustomMenuItem";
import DataTablePagination from "./src/components/DataTable/Pagination";
import DataTableStatusCell from "./src/components/DataTable/StatusCell";
import DataTableDefaultCell from "./src/components/DataTable/DefaultCell";
import DataTableHeadCell from "./src/components/DataTable/DataTableHeadCell";
import DataTableBodyCell from "./src/components/DataTable/DataTableBodyCell";

import ModalSearchUser from "./src/components/ModalSearchUser";
import UserProfileDropdown from "./src/components/UserProfileDropdown";
import { InputAddress, ModalAddress } from "./src/components/Address";
import { MenuBar, MenuBarRecursion, MenuBarEliminateRecursion } from "./src/components/MenuBar";
import { RoleHelpers } from "./src/commons/roleHelpers";

// *** Interface *** //
export type {
    IItemRoute,
    IUserProfile,
    IPropListContainer,
    IPropDetailContainer,
    IPropModuleContainer,
    KeyModuleScreen,
    IFileUploaderRes,
    IAssetInfo,
    IInvitation,
    IResourcePemssions,
    ITableGroup
} from "./src/commons/interfaces";

export type { IRoleBitMask } from "./src/commons/roleHelpers";
export { RoleType, RoleLevel, RoleTab, PolicyRequirementType, GroupCompareType } from "./src/constants/enums";

// *** Components *** //
export {
    CommonComponentProvider,
    useCommonComponentContext,

    // *** Common Container *** //
    ProfileContainer,
    ModuleCodename,
    CodenameContainer,
    getAllDataCodename,
    CodenameEditContainer,
    ModalCreateEditCodename,
    ModuleRole,
    RoleContainer,
    RoleEditContainer,
    ModuleResource,
    ResourceContainer,
    ResourceEditContainer,
    ModuleStaff,
    StaffListContainer,
    StaffEditContainer,
    ModalCreateUpdateStaff,
    ModalInvitationMember,
    ModuleGroup,
    GroupListContainer,
    GroupEditContainer,
    ModalCreateUpdateGroup,
    CardCreateUpdateGroup,
    ModuleOrganization,
    ModalManageOrganization,
    OrganizationListContainer,
    OrganizationEditContainer,
    OrganizationGroupComponent,
    OrganizationStaffComponent,
    OrganizationBasicInfoComponent,
    InvitationListContainer,
    MyInvitationContainer,
    PDFViewerContainer,
    WorkerNodeContainer,

    // *** Common Component *** //
    Box,
    Chip,
    Tabs,
    Modal,
    Button,
    Switch,
    Stepper,
    Loading,
    CustomIcon,
    TitleValue,
    Typography,
    Breadcrumbs,
    Avatar,
    AvatarPicker,
    CustomPopupMenu,
    CustomPagination,
    Radio,
    CheckBox,
    RadioGroup,
    ControlLabelCheckBox,
    TabMultiLanguage,
    SelectMultiLanguage,
    SelectBox,
    Autocomplete,
    // Input //
    TextField,
    FormField,
    EmailInput,
    InputListEmail,
    InputHtmlEditor,
    QuillHtmlEditor,
    InputHtmlUploadEditor,
    SearchInputAPI,
    PhoneNumberInput,
    CircularProgress,
    ColorPicker,
    SingleImageUploader,
    ImageLibrary,

    // Date time picker //
    TimePicker,
    DatePicker,
    DateTimePicker,

    // Component Snackbar //
    CustomSnackbar,
    SnackbarAlert,
    SnackbarMessage,

    // Component Uploader //
    VideoPlayer,
    FileUploader,
    VideoUploader,
    ImageUploader,
    MultipleImageUploader,

    // Component Table //
    DataTable,
    CustomMenuItem,
    DataTableFilter,
    DataTableBodyCell,
    DataTableHeadCell,
    DataTablePagination,
    DataTableStatusCell,
    DataTableDefaultCell,
    MenuBar,
    MenuBarRecursion,
    MenuBarEliminateRecursion,

    //
    InputAddress,
    ModalAddress,
    ModalSearchUser,
    UserProfileDropdown,

    // FAQ
    Faq,
    RoleHelpers,
};
